/**
 * Created by  on 2017/4/19.
 */
/**
 * Operate localStorage like an Array
 *
 */
class LocaleStorageSet {
    constructor(key, len, trackBy) {
        this.key = key;
        this.len = len;
        this.trackBy = trackBy;
        this.data = this.read()
    }

    read() {
        const ls = localStorage.getItem(this.key) || '[]';
        return JSON.parse(ls);
    }

    write() {
        if (this.data.length > this.len) {
            this.data.length = this.len;
        }
        const ls = JSON.stringify(this.data);
        try {
            localStorage.setItem(this.key, ls);
        } catch (ex) {
            console.error(ex.message)
            return false;
        }
        return true;
    }

    // return true on repeat item found
    checkRepeat(needle) {
        const trackBy = this.trackBy;
        return this.data.some((item) => {
            if (trackBy) {
                return item[trackBy] === needle[trackBy];
            } else {
                return item === needle;
            }
        });
    }

    push(item) {
        if (this.checkRepeat(item)) {
            return;
        }
        this.data.push(item)
        return this.write()
    }

    unshift(item) {
        if (this.checkRepeat(item)) {
            return;
        }
        this.data.unshift(item)
        return this.write()
    }

    pop() {
        const item = this.data.pop()
        this.write()
        return item
    }

    shift() {
        const item = this.data.shift()
        this.write()
        return item
    }

    getAll() {
        return this.read()
    }

    clear () {
        if (this.data.length > 0) {
            this.data = []
            localStorage.setItem(this.key, '[]')
        }
    }
}

export default LocaleStorageSet;
